// @flow
import {
  call,
  takeEvery,
  put,
  select,
  race,
} from 'redux-saga/effects';
import { normalize } from 'normalizr';
import { delay } from 'redux-saga';
import i18n from 'i18n-js';

import { REQUEST_TIMEOUT } from '../settings';
import { throwTimeout } from '../lib/http';
import HTTP_STATUS from '../lib/HTTPStatus';
import {
  CHANGE_STOP_REQUEST_FETCH_STARTED,
  CHANGE_STOP_REQUEST_CREATE_STARTED,
  CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED,
  FETCH_CHANGE_STOP_REQUEST_COUNTER,
} from '../types/changeStopRequest';
import * as selectors from '../reducers';
import * as changeStopRequestActions from '../actions/changeStopRequests';
import * as closeableActions from '../actions/closeable';
import * as routeActions from '../actions/routes';
import * as studentActions from '../actions/students';
import * as gatewayActions from '../actions/gateways';
import { School, ChangeStopRequest } from '../api';
import { changeStopRequest, arrayOfChangeStopRequest } from '../api/schemas/changeStopRequest';
import * as temporalBannersActions from '../actions/temporalBanners';
import {
  DEFAULT_CREATE, DEFAULT_DURATION, DEFAULT_UPDATE, FETCH_ERROR, UPDATE_ERROR, CREATE_ERROR,
} from '../utils/errorDefaults';

function getDates(startDate, stopDate) {
  const dateArray = [];
  const currentDate = startDate;
  while (currentDate <= stopDate) {
    dateArray.push(new Date(currentDate).toISOString());
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dateArray;
}

function* fetchChangeStopRequest(action) {
  const token = yield select(selectors.getToken);
  const profile = yield select(selectors.getProfileOfType, 'admin');
  try {
    const mock = {
      delay: 0,
      response: {
        statusCode: 200,
        statusText: 'ok',
        body: [
          {
            id: 1,
            from_stop: {
              id: 1,
              stop_type: 'test',
              name: 'fromStop',
              short_name: 'fromStop',
              address: 'fromStop',
              city: 'fromStop',
              country: 'fromStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            state: 'pending',
            to_stop: {
              id: 2,
              stop_type: 'test',
              name: 'toStop',
              short_name: 'toStop',
              address: 'toStop',
              city: 'toStop',
              country: 'toStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            requestedBy: {
              id: 1,
              first_name: 'test name',
              last_name: 'test last name',
              profile_type: 'parent',
            },
            student: {
              id: 1,
              first_name: 'test student',
              last_name: 'test student',
              code: '123',
              profile_picture: '',
              school: 1,
              is_present: true,
              isDropped: false,
              route_stops: [],
            },
            dateRequested: '',
            dateApproved: '',
            approvedBy: {
              id: 1,
              profile_type: 'admin',
              first_name: 'Test',
              last_name: 'admin',
              phone: '9678867',
              code: '7777',
            },
            description: 'esta es la descripcion del change stop request.',
          },
          {
            id: 2,
            from_stop: {
              id: 1,
              stop_type: 'test',
              name: 'fromStop',
              short_name: 'fromStop',
              address: 'fromStop',
              city: 'fromStop',
              country: 'fromStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            state: 'pending',
            to_stop: {
              id: 1,
              stop_type: 'test',
              name: 'toStop',
              short_name: 'toStop',
              address: 'toStop',
              city: 'toStop',
              country: 'toStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            requestedBy: {
              id: 1,
              first_name: 'test name',
              last_name: 'test last name',
              profile_type: 'parent',
            },
            student: {
              id: 1,
              first_name: 'test student',
              last_name: 'test student',
              code: '123',
              profile_picture: '',
              school: 1,
              is_present: true,
              isDropped: false,
              route_stops: [],
            },
            dateRequested: '',
            dateApproved: '',
            approvedBy: {
              id: 1,
              profile_type: 'admin',
              first_name: 'Test',
              last_name: 'admin',
              phone: '9678867',
              code: '7777',
            },
            description: 'esta es la descripcion del change stop request.',
          },
          {
            id: 3,
            from_stop: {
              id: 1,
              stop_type: 'test',
              name: 'fromStop',
              short_name: 'fromStop',
              address: 'fromStop',
              city: 'fromStop',
              country: 'fromStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            state: 'pending',
            to_stop: {
              id: 1,
              stop_type: 'test',
              name: 'toStop',
              short_name: 'toStop',
              address: 'toStop',
              city: 'toStop',
              country: 'toStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            requestedBy: {
              id: 1,
              first_name: 'test name',
              last_name: 'test last name',
              profile_type: 'parent',
            },
            student: {
              id: 1,
              first_name: 'test student',
              last_name: 'test student',
              code: '123',
              profile_picture: '',
              school: 1,
              is_present: true,
              isDropped: false,
              route_stops: [],
            },
            dateRequested: '',
            dateApproved: '',
            approvedBy: {
              id: 1,
              profile_type: 'admin',
              first_name: 'Test',
              last_name: 'admin',
              phone: '9678867',
              code: '7777',
            },
            description: 'esta es la descripcion del change stop request.',
          },
          {
            id: 4,
            from_stop: {
              id: 1,
              stop_type: 'test',
              name: 'fromStop',
              short_name: 'fromStop',
              address: 'fromStop',
              city: 'fromStop',
              country: 'fromStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            state: 'pending',
            to_stop: {
              id: 1,
              stop_type: 'test',
              name: 'toStop',
              short_name: 'toStop',
              address: 'toStop',
              city: 'toStop',
              country: 'toStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            requestedBy: {
              id: 1,
              first_name: 'test name',
              last_name: 'test last name',
              profile_type: 'parent',
            },
            student: {
              id: 1,
              first_name: 'test student',
              last_name: 'test student',
              code: '123',
              profile_picture: '',
              school: 1,
              is_present: true,
              isDropped: false,
              route_stops: [],
            },
            dateRequested: '',
            dateApproved: '',
            approvedBy: {
              id: 1,
              profile_type: 'admin',
              first_name: 'Test',
              last_name: 'admin',
              phone: '9678867',
              code: '7777',
            },
            description: 'esta es la descripcion del change stop request.',
          },
          {
            id: 5,
            from_stop: {
              id: 1,
              stop_type: 'test',
              name: 'fromStop',
              short_name: 'fromStop',
              address: 'fromStop',
              city: 'fromStop',
              country: 'fromStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            state: 'pending',
            to_stop: {
              id: 1,
              stop_type: 'test',
              name: 'toStop',
              short_name: 'toStop',
              address: 'toStop',
              city: 'toStop',
              country: 'toStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            requestedBy: {
              id: 1,
              first_name: 'test name',
              last_name: 'test last name',
              profile_type: 'parent',
            },
            student: {
              id: 1,
              first_name: 'test student',
              last_name: 'test student',
              code: '123',
              profile_picture: '',
              school: 1,
              is_present: true,
              isDropped: false,
              route_stops: [],
            },
            dateRequested: '',
            dateApproved: '',
            approvedBy: {
              id: 1,
              profile_type: 'admin',
              first_name: 'Test',
              last_name: 'admin',
              phone: '9678867',
              code: '7777',
            },
            description: 'esta es la descripcion del change stop request.',
          },
          {
            id: 6,
            from_stop: {
              id: 1,
              stop_type: 'test',
              name: 'fromStop',
              short_name: 'fromStop',
              address: 'fromStop',
              city: 'fromStop',
              country: 'fromStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            state: 'pending',
            to_stop: {
              id: 1,
              stop_type: 'test',
              name: 'toStop',
              short_name: 'toStop',
              address: 'toStop',
              city: 'toStop',
              country: 'toStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            requestedBy: {
              id: 1,
              first_name: 'test name',
              last_name: 'test last name',
              profile_type: 'parent',
            },
            student: {
              id: 1,
              first_name: 'test student',
              last_name: 'test student',
              code: '123',
              profile_picture: '',
              school: 1,
              is_present: true,
              isDropped: false,
              route_stops: [],
            },
            dateRequested: '',
            dateApproved: '',
            approvedBy: {
              id: 1,
              profile_type: 'admin',
              first_name: 'Test',
              last_name: 'admin',
              phone: '9678867',
              code: '7777',
            },
            description: 'esta es la descripcion del change stop request.',
          },
        ],
      },
    };
    // Create  route
    const { changeStopRequestResponse, timeout } = yield race({
      changeStopRequestResponse: call(
        [School.custom, 'changeStopRequests'],
        {
          token,
          id: profile.school,
          filters: {
            ...action.payload.filters,
            page_size: 25,
          },
          mock,

        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),

    });
    if (timeout) {
      throwTimeout('fetchRoutes saga');
    }
    // Normalizing response
    const {
      entities,
      result,
    } = normalize(changeStopRequestResponse.results, arrayOfChangeStopRequest);
    const { next } = changeStopRequestResponse;
    const { gateways, routeStops, students } = entities;

    if (routeStops) {
      // Adding route stops.
      for (let i = 0; i < Object.keys(routeStops).length; i += 1) {
        const key = Object.keys(routeStops)[i];
        yield put(
          routeActions.fetchRouteStopsSucceed(
            routeStops[key].route,
            {
              [parseInt(key, 10)]: routeStops[key],
            },
            [parseInt(key, 10)],
          ),
        );
      }
    }
    if (gateways) {
      // Adding route gateways.
      yield put(
        gatewayActions.gatewaysFetchSucceed(
          gateways,
          Object.keys(gateways).map(id => parseInt(id, 10)),
        ),
      );
    }

    if (students) {
      // Adding students.
      const keys = Object.keys(students);
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        students[key] = {
          ...students[key],
          changeStopRequests: Object.values(entities.changeStopRequest).map(req => req.id),
        };
      }

      yield put(
        studentActions.fetchStudentsSucceed(
          students,
          Object.keys(students).map(id => parseInt(id, 10)),
        ),
      );
    }

    // Change the current filter if there was a change on the state viewed.
    if (action.payload.filters.state) {
      yield put(
        changeStopRequestActions.changeFilterChangeStopRequests(
          action.payload.filters.state,
        ),
      );
    }
    yield put(
      changeStopRequestActions.fetchChangeStopRequestSucceed(
        entities.changeStopRequest,
        result,
        next,
      ),
    );
  } catch (error) {
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    if (statusCode !== HTTP_STATUS.NOT_FOUND) {
      yield put(temporalBannersActions.shout(FETCH_ERROR(i18n.t('common.changeStopRequest', { count: 2 })), DEFAULT_DURATION, -1, {}));
    }
    yield put(changeStopRequestActions.fetchChangeStopRequestFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al traer solicitudes de cambio de parada' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* updateStateChangeStopRequest(action) {
  const token = yield select(selectors.getToken);
  const changeStopRequestObj = yield select(
    selectors.getChangeStopRequest,
    action.payload.changeStopRequestId,
  );
  const student = yield select(selectors.getStudent, changeStopRequestObj.student);
  const profile = yield select(selectors.getProfileOfType, 'admin');
  try {
    const mock = {
      delay: 0,
      response: {
        statusCode: 200,
        statusText: 'ok',
        body: [
          {
            id: 6,
            from_stop: {
              id: 1,
              stop_type: 'test',
              name: 'fromStop',
              short_name: 'fromStop',
              address: 'fromStop',
              city: 'fromStop',
              country: 'fromStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            state: action.payload.state,
            to_stop: {
              id: 1,
              stop_type: 'test',
              name: 'toStop',
              short_name: 'toStop',
              address: 'toStop',
              city: 'toStop',
              country: 'toStop',
              point: { latitude: 0, longitude: 0 },
              students: [],
              eta: '1',
              route: 1,
            },
            requestedBy: {
              id: 1,
              first_name: 'test name',
              last_name: 'test last name',
              profile_type: 'parent',
            },
            student: {
              id: 1,
              first_name: 'test student',
              last_name: 'test student',
              code: '123',
              profile_picture: '',
              school: 1,
              is_present: true,
              isDropped: false,
              route_stops: [],
            },
            dateRequested: '',
            dateApproved: '',
            approvedBy: {
              id: 1,
              profile_type: 'admin',
              first_name: 'Test',
              last_name: 'admin',
              phone: '9678867',
              code: '7777',
            },
            description: 'esta es la descripcion del change stop request.',
          },
        ],
      },
    };
    // Create  route
    const { changeStopRequestResponse, timeout } = yield race({
      changeStopRequestResponse: call(
        [ChangeStopRequest.custom, 'updateState'],
        {
          token,
          id: changeStopRequestObj.id,
          data: {
            role: 'admin',
            profile: profile.id,
            instance_type: action.payload.instance_type,
            state: action.payload.state,
            description: action.payload.description,

          },
          mock,
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('fetchRoutes saga');
    }

    // Normalizing response
    const { entities } = normalize(changeStopRequestResponse, arrayOfChangeStopRequest);
    yield put(temporalBannersActions.shout(DEFAULT_UPDATE(i18n.t('common.changeStopRequest', { count: 1 })), DEFAULT_DURATION, 1, {}));
    yield put(changeStopRequestActions.updateStateChangeStopRequestSuccess(
      changeStopRequestResponse,
    ));

    // Update counter
    yield put(changeStopRequestActions.fetchChangeStopCounter());

  } catch (error) {
    yield put(temporalBannersActions.shout(UPDATE_ERROR(i18n.t('common.changeStopRequest', { count: 1 })), DEFAULT_DURATION, -1, {}));
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(changeStopRequestActions.changeStopRequestCreateFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al al actualizar la solicitud de cambio' : 'error',
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* createChangeStopRequest(action) {
  const token = yield select(selectors.getToken);
  const changeStopRequestData = action.payload;
  try {
    // Create  route
    const { changeStopRequestResponse, timeout } = yield race({
      changeStopRequestResponse: call(
        [ChangeStopRequest, 'create'],
        {
          token,
          id: changeStopRequest.id,
          data: {
            ...changeStopRequestData,
          },
        },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });

    if (timeout) {
      throwTimeout('createRoute saga');
    }
    // Normalizing response
    const { entities, result, ...rest } = normalize(
      changeStopRequestResponse,
      arrayOfChangeStopRequest,
    );
    yield put(temporalBannersActions.shout(DEFAULT_CREATE(i18n.t('common.changeStopRequest', { count: 1 })), DEFAULT_DURATION, 1, {}));
    yield put(changeStopRequestActions.fetchChangeStopRequestSucceed(entities.changeStopRequest, result));
    yield put(closeableActions.close('createChangeStopRequest'));
  } catch (error) {
    yield put(temporalBannersActions.shout(CREATE_ERROR(i18n.t('common.changeStopRequest', { count: 1 })), DEFAULT_DURATION, -1, {}));
    // Set error
    const {
      statusCode,
      message,
      data,
      isPlain,
    } = error;
    yield put(changeStopRequestActions.fetchChangeStopRequestFailed({
      statusCode,
      message: statusCode === HTTP_STATUS.NOT_FOUND ? 'Error al traer solicitudes de cambio de parada' : message,
      data: isPlain ? 'Error en el servidor' : data,
      retryAction: action,
    }));
  }
}

function* fetchCounter(action) {
  const token = yield select(selectors.getToken);
  const profile = yield select(selectors.getProfileOfType, 'admin');

  try {
    const { response, timeout } = yield race({
      response: call(
        [School.custom, 'changeStopRequestsCounter'],
        { token, id: profile.school },
      ),
      timeout: call(delay, REQUEST_TIMEOUT),
    });
  
    if (timeout) {
      throwTimeout('fetchRoutes saga');
    }

    yield put(changeStopRequestActions.successFetchChangeStopCounter(response.count));

  } catch (e) {
    // noop
  }
}

export function* watchFetchChangeStopRequest(): Iterator<any> {
  yield takeEvery(
    CHANGE_STOP_REQUEST_FETCH_STARTED,
    fetchChangeStopRequest,
  );
}

export function* watchupdateStateChangeStopRequest(): Iterator<any> {
  yield takeEvery(
    CHANGE_STOP_REQUEST_CHANGE_STATE_STARTED,
    updateStateChangeStopRequest,
  );
}

export function* watchCreateChangeStopRequest(): Iterator<any> {
  yield takeEvery(
    CHANGE_STOP_REQUEST_CREATE_STARTED,
    createChangeStopRequest,
  );
}

export function* watchFetchChangeStopRequestCounter(): Iterator<any> {
  yield takeEvery(
    FETCH_CHANGE_STOP_REQUEST_COUNTER,
    fetchCounter,
  );
}



// WEBPACK FOOTER //
// ./src/scripts/sagas/changeStopRequests.js